import { FormattedMessage } from 'react-intl';

import { TRequirementProps } from '../../fundingRequirements.types';
import { RequirementItem } from '../RequirementItem/RequirementItem';

export const UploadGewerbeschein = ({ status }: TRequirementProps) => {
    return (
        <RequirementItem
            title={
                <FormattedMessage
                    id="_.funding_requirements_v2.type.upload_gewerbeschein"
                    defaultMessage="Upload your Gewerbeschein"
                />
            }
            estimatedTime={
                <FormattedMessage
                    id="_.funding_requirements_v2.time.2_min"
                    defaultMessage="~ 2 Min."
                />
            }
            status={status}
        />
    );
};
